module.exports = __webpack_public_path__ + "img/play.cbd35458.png";